// import React from "react";
import LogoNav from "../../assets/images/logo-nav.webp";
import Polygon from "../../assets/images/Polygon.webp";
import AtomIcon from "../../assets/images/UnionWhite.webp";
import UserImage from "../../assets/images/user.webp";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import './QuestionsSection.css';
import React, { useState, useEffect } from 'react';
import AnswerIcon from "../../assets/images/UnionWhite.webp";

const QuestionsSection = () => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [activeIndex, setActiveIndex] = useState(0);
  const questions = [
    {
      question: "Same Rashi, same rashifal, but completely different lives. Why?",
      answer: "Because your rashi is just one part of your Vedic astrology chart! MyNaksh studies 100+ data points paired with your life’s kundali and context to give you a free, daily horoscope that guides you personally, every day."
    },
    {
      question: "My life has had so many ups and downs. Why did things unfold this way?",
      answer: "Our Life Dashboard offers a clear life prediction by date of birth, analyzing effects of all transits like the Shani Gochar (शनि गोचर) and Guru Gochar (गुरु गोचर), to help you understand your your past and present phases."
    },
    {
      question: "I want to know the right day to start important things, like a new project or travels.",
      answer: "Vedic astrology shows us windows of opportunity. MyNaksh helps you take advantage, helping you find shubh muhurats through daily panchang, and auspicious days to plan each month to the best of your destiny."
    }
  ];
  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <div className="questions-section-container">
      {/* Heading */}
      <div className="questions-heading-container">
        <p className="questions-main-heading">
          <span>Your Vedic Astrology Questions, Answered. </span>
          
        </p>
      </div>

      {/* Q&A Swiper for Mobile, Grid for Desktop */}
      {isMobileView ? (
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          centeredSlides={false}
          loop={true}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          className="questions-swiper"
          onSlideChange={handleSlideChange}
        >
          {questions.map((q, index) => (
            <SwiperSlide key={index}>
              <div className="questions-card">
                <div className="questions-bubble-wrapper">
                  <div className="questions-bubble">
                    {q.question}
                  </div>
                  <div className="questions-bubble-tail-white"></div>
                  <div className="questions-bubble-tail-border"></div>
                </div>
                <div className="questions-answer-box">
                  <img src={AtomIcon} alt="icon" className="questions-answer-icon" loading="lazy" />
                  <p className="questions-answer-text">
                    {q.answer}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={3}
          centeredSlides={false}
          loop={true}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          className="questions-swiper-desktop"
          onSlideChange={handleSlideChange}
        >
          {questions.map((question, idx) => (
            <SwiperSlide key={idx} className={activeIndex === idx ? "questions-slide-active" : "questions-slide"}>
              <div className="questions-card">
                <div className="questions-bubble-wrapper">
                  <div className="questions-bubble">
                    {question.question}
                  </div>
                  <div className="questions-bubble-tail-white"></div>
                  <div className="questions-bubble-tail-border"></div>
                </div>
                <div className="questions-answer-box">
                  <img src={AnswerIcon} alt="Answer Icon" className="questions-answer-icon" loading="lazy" />
                  <p className="questions-answer-text">{question.answer}</p>
                  <div
  className={`questions-answer-tail animate`}
  style={{
    '--tail-offset':
      idx === 0 ? '80px' : idx === 1 ? '0px' : idx === 2 ? '-80px' : '0px'
  }}
></div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}

      {/* Polygon Footer Shape */}
      
      <img
        src={Polygon}
        alt="polygon"
        className="questions-polygon"
        loading="lazy"
      />
      <div className="questions-footer">
  <img
    src={LogoNav}
    alt="logo"
    className="questions-logo"
    loading="lazy"
  />
  <span className="navbar-title font-recoleta">MyNaksh</span>
    </div>
    </div>
  );
};

export default QuestionsSection;
